<template>
	<div>
		<h1>Debi/Kredi - Offene Posten</h1>
		<button @click="$router.push({ path: '/home/arap/processing'})"><i class="fas fa-plus"></i> OP erfassen</button>
		<button @click="$router.push({ path: '/home/arap/transfer'})"><i class="fas fa-exchange-alt"></i> Datentransfer</button>
		<button @click="open_download_dlg"><i class="fas fa-download"></i> Download</button>
		<button @click="$router.push({ path: '/home/arap/pa'})"><i class="fas fa-building"></i> Personenkonten</button>
		<button @click="open_oplist_dlg"><i class="fas fa-building"></i> OP Liste</button>
		<!--input type="text" v-model="search_txt" placeholder="Suche..." @keyup.enter="search" class="left_space"-->
		
		<br>
		
		<div class="filterwrp">
			<div><i class="fas fa-filter"></i>Datum</div>
			<div>
				<select v-model="filter.date.mode" @change="date_filter_changed">
					<option value="">-- Keine Einschränkung --</option>
					<option value="jr_c">Aktuelles Jahr</option>
					<option value="jr_l">Letztes Jahr</option>
					<option value="qr_c">Aktuelles Quartal</option>
					<option value="qr_l">Letztes Quartal</option>
					<option value="mt_c">Aktueller Monat</option>
					<option value="mt_l">Letzter Monat</option>
					<option value="usrdef">Benutzerdefiniert</option>
				</select>
			</div>
			<div v-show="filter.date.mode === 'usrdef'" class="dateflds">
				<input type="text" v-model.lazy="filter.date.start" placeholder="Startdatum" :class="{date_err: !valid_start_date}" @change="populateDT()"> -
				<input type="text" v-model.lazy="filter.date.end" placeholder="Enddatum" :class="{date_err: !valid_end_date}" @change="populateDT()">
			</div>
		</div>
		
		<div class="filterwrp">
			<div><i class="fas fa-filter"></i>Typ</div>
			<div>
				<select v-model="filter.type" @change="populateDT()">
					<option value="">-- Keine Einschränkung --</option>
					<option value="ar">Debitoren</option>
					<option value="ap">Kreditoren</option>
				</select>
			</div>
		</div>
		
		<div class="filterwrp">
			<div><i class="fas fa-filter"></i>OP-Status</div>
			<div>
				<!--input type="checkbox" v-model="filter.only_due_invoices" id="flt_oponly" @change="populateDT()"> <label for="flt_oponly">Nur OPs anzeigen</label-->
				<select v-model="filter.payment_status" @change="populateDT()">
					<option value="">-- Keine Einschränkung --</option>
					<option value="outstanding">nur OPs</option>
					<option value="paid">nur bezahlt</option>
					<option value="overpaid">nur überzahlt</option>
				</select>
			</div>
		</div>
		
		<div class="filterwrp">
			<div><i class="fas fa-filter"></i>Status</div>
			<div>
				<select v-model="filter.status" @change="populateDT()">
					<option value="">-- Keine Einschränkung --</option>
					<option value="pending">in Arbeit</option>
					<option value="ready">freigegeben</option>
					<option value="submitted">übermittelt</option>
				</select>
			</div>
		</div>
		
		<div class="filterwrp">
			<div><i class="fas fa-filter"></i>Textsuche</div>
			<div>
				<input type="text" v-model.lazy.trim="filter.text" @change="populateDT()">
			</div>
		</div>
		
		<table>
			<thead>
				<th>Datum</th>
				<th>Personenkonto</th>
				<th>Bezeichnung</th>
				<th>Typ</th>
				<th>Beleg Nr.</th>
				<th>Whr</th>
				<th>Betrag</th>
				<th>Soll</th>
				<th>Haben</th>
				<th>OP</th>
				<th>Status</th>
				
				<th></th>
				<th></th>
				<th></th>
			</thead>
			<tbody>

				<tr v-for="(rec,idx) in recs" :key="rec.id">
					<td>{{ rec.date | recdate }}</td>
					<td>{{ rec.pa_name }}</td>
					<td>{{ rec.name }}</td>
					<td><span class="badge" :class="rec.type">{{ rec.type === 'ar' ? 'DEBI' : 'KREDI' }}</span></td>
					<td>{{ rec.refnum }}</td>
					<td>{{ rec.ccy }}</td>
					<td>{{ rec.amount }}</td>
					<td>{{ rec.debit_acct }}</td>
					<td>{{ rec.credit_acct }}</td>
					<td><i class="far" :class="{'fa-check-square': rec.payment_status != 'outstanding', 'fa-square': rec.payment_status == 'outstanding', 'redalert': rec.payment_status == 'overpaid'}" @click="toggle_payment_pending(idx)" :title="get_pmt_status_lbl(rec.payment_status)"></i></td>
					<td><span class="badge" :class="rec.status">{{ status_label(rec.status) }}</span></td>
					<td><a :href="$globals.API_REL_URL + 'arappdf.php?c=' + client_id + '&f=' + rec.doc_checksum" target="_blank" class="anl"><i class="far fa-file-pdf" title="PDF öffnen"></i></a></td>

					<td><i class="fas fa-pencil-alt" title="Bearbeiten" @click="editDoc(rec.id)"></i></td>
					<td><i class="fas fa-trash-alt" title="Löschen" @click="deleteShowDlg(rec.id)"></i></td>
				</tr>
			</tbody>
		</table>
		
		<modal name="modalSubmit" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Übermittlung bestätigen</div>
			<div class="delConf-content">
				'{{ selected_name }}' wirklich übermitteln?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="submitImportData" class="delConf-btn-del">Ja</button>
				<button @click="$modal.hide('modalSubmit')">Nein</button>
			</div>
		</modal>
		
		<modal name="modalDel" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Löschung bestätigen</div>
			<div class="delConf-content">
				Import-Daten '{{ selected_name }}' wirklich löschen?
			</div>
			<div class="delConf-button-wrapper">
				<button @click="deleteRec" class="delConf-btn-del">Löschen</button>
				<button @click="$modal.hide('modalDel')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalDownload" width="350" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">Beleg-Download</div>
			<div class="delConf-content">
				Mit den aktuellen Filtereinstellungen werden die betreffenden Belege in eine ZIP-Datei gepackt und heruntergeladen.
				<select v-model="download.filename_format" style="margin-top:10px;">
					<option value="">-- Format für Dateinamen wählen --</option>
					<option value="1">JJJJ_MM_TT-NamePersKto-Belegnummer.pdf</option>
					<option value="2">NamePersKto-JJJJ_MM_TT-Belegnummer.pdf</option>
				</select>
			</div>
			<div class="delConf-button-wrapper">
				<button @click="start_download" class="delConf-btn-del dnldbtn" :disabled="download.filename_format === ''">Download starten</button>
				<button @click="$modal.hide('modalDownload')">Abbrechen</button>
			</div>
		</modal>
		
		<modal name="modalOpList" width="300" height="auto" :clickToClose="false" draggable=".delConf-title">
			<div class="delConf-title">OP Liste</div>
			<div class="delConf-content">
				Typ:<br>
				<select v-model="oplist.type">
					<option value="">-- Typ wählen --</option>
					<option value="ar">Debitoren</option>
					<option value="ap">Kreditoren</option>
				</select>
				<br>
				<br>
				Währung:<br>
				<select v-model="oplist.ccy">
					<option value="">-- Währung wählen --</option>
					<option v-for="ccy in ccy_list" :key="ccy.iso_code" :value="ccy.iso_code">{{ ccy.iso_code }} - {{ ccy.description }}</option>
				</select>
				<br>
				<br>
				Stichtag:<br>
				<input type="text" v-model="oplist.date">
			</div>
			<div class="delConf-button-wrapper">
				<button @click="download_oplist" class="delConf-btn-del dnldbtn" :disabled="!oplist_data_valid">OK</button>
				<button @click="$modal.hide('modalOpList')">Abbrechen</button>
			</div>
		</modal>
		<vue-snotify></vue-snotify>
		<OpStatus ref="opstatus" @saved="populateDT()"></OpStatus>
		<iframe :src="download.src" style="position: absolute;width:0;height:0;border:0;"></iframe>
	</div>
</template>

<script>
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    components: {
		OpStatus: () => import('../organisms/OpStatus.vue')
	},
    mixins: [ApiComm],
	data() {
		return {
			selected_id: '',
			selected_name: '',
			recs: [],
			filter: {
				date: {
					mode: '',
					start: '',
					end: '',
				},
				payment_status: 'outstanding',
				type: '',
				status: '',
				text: ''
			},
			download: {
				filename_format: '',
				src: ''
			},
			oplist: {
				type: '',
				ccy: '',
				date: new Date().toLocaleDateString('de-DE')
			},
			ccy_list: [],
			download_count: 0
		}
	},
    computed: {
		client_id () {
			return this.$store.state.customer.id
		},
		
		valid_start_date () {
			if (/^[0-3]?[0-9]{1}\.[01]?[0-9]{1}\.(19|20)[0-9]{2}$/.test(this.filter.date.start) === false) return false;
			var d = this.$moment(this.filter.date.start, 'DD.MM.YYYY');
//console.log(this.filter.date.start + ' -> ' + (d.isValid() ? 'TRUE -> ' + d.format('YYYY-MM-DD') : 'FALSE'));
			return d.isValid();
		},
		
		valid_end_date () {
			if (/^[0-3]?[0-9]{1}\.[01]?[0-9]{1}\.(19|20)[0-9]{2}$/.test(this.filter.date.end) === false) return false;
			var d = this.$moment(this.filter.date.end, 'DD.MM.YYYY');
			return d.isValid();
		},
		
		oplist_data_valid () {
			var o = this.oplist;
			
			if (o.type == '') return false;
			if (o.ccy == '') return false;
			if (!this.isValidDate(o.date)) return false;
			
			return true;
		}
	},
    methods: {
		isValidDate(dateString) {
			// Überprüfen, ob das Datum dem Format DD.MM.YYYY entspricht
			const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/;

			if (!dateRegex.test(dateString)) {
				return false; // Das Datum entspricht nicht dem erwarteten Format
			}

			// Überprüfen, ob das Datum gültig ist (z. B. 31.02.2022 wäre ungültig)
			const parts = dateString.split('.');
			const day = parseInt(parts[0], 10);
			const month = parseInt(parts[1], 10) - 1; // Monate im JavaScript-Date-Objekt sind 0-basiert
			const year = parseInt(parts[2], 10);

			const dateObject = new Date(year, month, day);

			return (
				dateObject.getDate() === day &&
				dateObject.getMonth() === month &&
				dateObject.getFullYear() === year
			);
		},
		
		user2mysql_date(userDateInput) {
			const dateParts = userDateInput.split('.');
			const day = parseInt(dateParts[0], 10);
			const month = parseInt(dateParts[1], 10) - 1; // Monate sind 0-basiert
			const year = parseInt(dateParts[2], 10);

			// Datum im MySQL-Datumformat YYYY-MM-DD erstellen
			return `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
		},
		
		open_oplist_dlg() {
			if (this.ccy_list.length == 0) {
				var cid = this.$store.state.customer.id;
				this.apiCall([{method: 'client/param/currency/list', param: {client_id: cid}, id: 70}], this.evalApiResponse)
			}

			this.$modal.show('modalOpList');
		},
		
		download_oplist() {
			if (!this.isValidDate(this.oplist.date)) return;
			
			var o = this.oplist, p = 'c:'+this.$store.state.customer.id+'|arap:'+o.type+'|ccy:'+o.ccy+'|date:'+this.user2mysql_date(o.date);
			this.download_count++;
			this.download.src = this.$globals.API_REL_URL + 'opreport.php?c=' + btoa(p) + '&q='+this.download_count;
			this.$modal.hide('modalOpList');
		},
		
		open_download_dlg() {
			this.$modal.show('modalDownload');
		},
		
		start_download() {
			var f = this.filter, filter = {payment_status: f.payment_status};
			
			if (f.date.mode !== '') {
				if (this.valid_start_date) filter['start_date'] = this.$moment(f.date.start, 'DD.MM.YYYY').format('YYYY-MM-DD');
				if (this.valid_end_date) filter['end_date'] = this.$moment(f.date.end, 'DD.MM.YYYY').format('YYYY-MM-DD');
			}
			if (f.type !== '') filter['type'] = f.type;
			if (f.status !== '') filter['status'] = f.status;
			if (f.text !== '') filter['text'] = f.text;
			
			this.apiCall({method: 'arap/document/zip', param: {client_id: this.client_id, name_tpl: this.download.filename_format, filter: filter}, id: 99}, this.evalApiResponse)
			this.$modal.hide('modalDownload');
		},
		
		toggle_payment_pending(idx) {
//			console.log(JSON.stringify(this.recs[idx]));
			this.$refs.opstatus.open(this.recs[idx]);
		},
		
		date_filter_changed(o) {
//			console.log(o.target.value);
			var d = this.$moment(), f = 'DD.MM.YYYY', start = false, end;
			
			switch (o.target.value) {
				case '': //Keine Einschränkung
					this.populateDT();
					break;
				case 'jr_c': //Aktuelles Jahr
					start = d.startOf('year').format(f);
					end = d.endOf('year').format(f);
					break;
				case 'jr_l': //Letztes Jahr
					d = d.add(-1,'year');
					start = d.startOf('year').format(f);
					end = d.endOf('year').format(f);
					break;
				case 'qr_c': //Aktuelles Quartal
					start = d.startOf('quarter').format(f);
					end = d.endOf('quarter').format(f);
					break;
				case 'qr_l': //Letztes Quartal
					d = d.add(-1,'quarter');
					start = d.startOf('quarter').format(f);
					end = d.endOf('quarter').format(f);
					break;
				case 'mt_c': //Aktueller Monat
					start = d.startOf('month').format(f);
					end = d.endOf('month').format(f);
					break;
				case 'mt_l': //Letzter Monat
					d = d.add(-1,'month');
					start = d.startOf('month').format(f);
					end = d.endOf('month').format(f);
					break;
				case 'usrdef': //Benutzerdefiniert
					return;
			}

			if (start !== false) {
				this.filter.date.start = start;
				this.filter.date.end = end;
				this.populateDT();
			}
		},
		
		get_pmt_status_lbl(status) {
			switch (status) {
				case 'outstanding': return 'vollständige Zahlung ausstehend';
				case 'paid': return 'bezahlt';
				case 'overpaid': return 'überzahlt';
				default: return '';
			}
		},
		
		status_label(status) {
			switch (status) {
				case 'pending': return 'in Arbeit';
				case 'ready': return 'freigegeben';
				case 'submitted': return 'übermittelt';
				default: return '';
			}
		},
		
		deleteShowDlg: function (rid) {
			this.selected_id = rid
			this.selected_name = ''
			var i
			for(i=0; i<this.recs.length; i++) {
				if (this.recs[i].id === rid) {
					this.selected_name = this.recs[i].name
					break
				}
			}
			this.$modal.show('modalDel')
		},
		deleteRec: function () {
			var vm = this
			vm.apiCall([{method: 'arap/document/delete', param: {id: vm.selected_id}, id: 12},{method: 'arap/document/list', param: {client_id: vm.client_id}, if: [{id: 12, path: 'result/success', eq: true}], id: 10}], this.evalApiResponse)
			this.$modal.hide('modalDel')
		},
		editDoc: function (rid) {
//			var vm = this
//			vm.apiCall([{method: 'import/load', param: {id: rid}, id: 20}], vm.evalApiResponse)
			this.$router.push({ path: '/home/arap/document/edit/'+rid})
		},
		submitShowDlg: function (rid) {
			this.selected_id = rid
			this.selected_name = ''
			var i
			for(i=0; i<this.recs.length; i++) {
				if (this.recs[i].id === rid) {
					this.selected_name = this.recs[i].name
					break
				}
			}
			this.$modal.show('modalSubmit')
		},
		submitImportData: function () {
			var vm = this, rid = vm.selected_id
			vm.apiCall([{method: 'import/submit/enter', param: {import_id: rid}, id: 30},{method: 'import/list', param: {client_id: vm.client_id}, if: [{id: 30, path: 'result/success', eq: true}], id: 10}], vm.evalApiResponse)
			this.$modal.hide('modalSubmit')
		},
		
		populateDT: function () {
			var vm = this, f = this.filter, filter = {payment_status: f.payment_status};
			
			if (f.date.mode !== '') {
				if (this.valid_start_date) filter['start_date'] = this.$moment(f.date.start, 'DD.MM.YYYY').format('YYYY-MM-DD');
				if (this.valid_end_date) filter['end_date'] = this.$moment(f.date.end, 'DD.MM.YYYY').format('YYYY-MM-DD');
			}
			if (f.type !== '') filter['type'] = f.type;
			if (f.status !== '') filter['status'] = f.status;
			if (f.text !== '') filter['text'] = f.text;
			
			vm.apiCall([{method: 'arap/document/list', param: {client_id: vm.client_id, filter: filter}, id: 10}], vm.evalApiResponse);
		},
		
		evalApiResponse: function (resp) {
			var vm = this
			this.$_.forEach(resp, function (value) {
			  if (value.hasOwnProperty('id')) {
				switch (value.id) {
				  case 10: // 10 = Result from 'import/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
/*
{
  "result": [
    {
      "id": "3",
      "date": "2022-03-06",
      "name": "Test",
      "type": "ar",
      "amount": "29.00",
      "debit_acct": "290023",
      "credit_acct": "6550",
      "payment_pending": "1",
      "status": "submitted"
    },
    {
      "id": "2",
      "date": "2022-02-06",
      "name": "Test",
      "type": "ap",
      "amount": "29.00",
      "debit_acct": "290023",
      "credit_acct": "6550",
      "payment_pending": "1",
      "status": "ready"
    },
    {
      "id": "1",
      "date": "2022-01-06",
      "name": "Test",
      "type": "ap",
      "amount": "29.00",
      "debit_acct": "290023",
      "credit_acct": "6550",
      "payment_pending": "1",
      "status": "pending"
    }
  ],
  "id": 10
}
*/
						vm.recs = value.result
					}
					break
				  case 12: // 12 = Result from 'arap/document/delete'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.$snotify.success('OP gelöscht', 'OK')
					}
					break
				  case 20: // 20 = Result from 'import/load'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
			//						console.log(value)
						vm.$store.commit('set_import_param', value.result)
						vm.$router.push({ path: '/home/import/upload'})
					}
					break
				  case 30: // 30 = Result from 'import/submit/enter'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						if (value.result.hasOwnProperty('incomplete')) vm.$snotify.error('Die Daten wurden übermittelt. Siehe Buchungsprotokoll für Details.', 'ERROR', {timeout: 8000})
						else vm.$snotify.success('Die Daten wurden verbucht', 'OK')
					}
					break
				  case 70: // 70 = Result from 'client/param/currency/list'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.ccy_list = value.result;
//						vm.ccy_list.push({});
//						vm.ccy_list.pop();
					}
					break
				  case 99: // 99 = Result from 'arap/document/zip'
					if (value.hasOwnProperty('error')) {
						vm.$snotify.error(value.error.message, 'ERROR', {timeout: 8000})
					} else {
						vm.download.src = vm.$globals.API_REL_URL + 'arappdf.php?c=' + vm.client_id + '&f=' + value.result.token;
					}
					break
				}
			  }
			})
		}
    },
    filters: {
		recdate: function (val) {
			var a = val.substr(0,10).split('-')
			return a[2] + '.' + a[1] + '.' + a[0]
		},
		recstatus: function (val) {
			switch(val) {
				case 'PENDING': return 'AUSSTEHEND'
				case 'DOWNLOADED': return 'HERUNTERGELADEN'
				case 'SUBMITTED': return 'ÜBERMITTELT'
				default: return ''
			}
		}
    },
    watch: {
		client_id (newVal, oldVal) {
			this.populateDT();
		}
    },
    mounted: function () {
		this.populateDT();
    }
  }
</script>

<style scoped="">
button {
	border: 1px solid #000;
	background: #888;
	color: #fff;
	margin-bottom: 20px;
	margin-right: 5px;
	padding: 5px 10px;
	cursor: pointer;
	font-weight: 700;
}

button:hover {
	background: #666;
}

table {
	border-collapse: collapse;
	border: 1px solid #888;
	margin-bottom: 20px;
}

th {
	background: #317dff;
	color: #fff;
	padding: 10px 10px;
	min-width: 30px;
	text-align: left;
	border-bottom: 1px solid #888;
}

td {
	color: #333;
	padding: 10px 10px;
	text-align: left;
}

tr:nth-child(even) {background: #eee}
tr:nth-child(odd) {background: #fff}

tr.approved {background: #a9ffa9}

td > i {
	cursor: pointer;
}

input[type=text], select {
	border: 1px solid #888;
	padding:3px;
	background: #fff;
}

.badge {
	border-radius: 5px;
	padding: 3px 5px;
	color: #fff;
}

.badge.ar {
	background: #1E90FF;
}

.badge.ap {
	background: #AF04AF;
}

.badge.pending {
	background: #888;
}

.badge.ready {
	background: #FFA500;
}

.badge.submitted {
	background: #008000;
}


/* CONFIRM DELETION*/
.delConf-title {
	cursor: move;
	font-weight: 700;
	line-height: 40px;
	border-bottom: 1px solid #aaa;
	padding: 0 10px;
}

.delConf-content {
	padding: 20px 10px;
}

.delConf-button-wrapper {
	border-top: 1px solid #aaa;
	padding: 10px 10px 0 10px;
}

.delConf-button-wrapper button {
	margin-left: 5px;
}

.delConf-btn-del {
	background: #c00;
}

.delConf-btn-del:hover {
	background: #a00;
}

.disabled {
	cursor: auto;
	color: #aaa;
}

.anl {
	text-decoration: none;
	color: #000;
}


.filterwrp {
	display: inline-flex;
	flex-direction: column;
	background: #fff;
	border: 1px solid #888;
	margin-bottom: 10px;
	margin-right: 10px;
}

.filterwrp > div {
	padding: 5px;
}

.filterwrp > div:first-child {
	color: #eee;
	background: #888;
	font-weight: bold;
}
.filterwrp > div:first-child > i {
	margin-right: 5px;
}

.filterwrp .dateflds > input[type=text] {
	width: 85px;
}

.date_err {
	background: #fcc!important;
}

.dnldbtn:disabled {
	opacity: 0.33;
	cursor: inherit;
}

.redalert {
	color: #f00;
}
</style>
